import React from 'react';
import { DatePicker, Form, InputNumber, List } from 'antd';
import Button from 'app/components/Button';
import styled from '@emotion/styled';
import ModalAssignInspector from '../../Modals/AssignInspector';
import Card from 'app/components/Card';
import sum from 'lodash/sum';
import Avatar from 'app/components/Avatar';
import moment, { isMoment } from 'moment';
import { Field, useFormikContext } from 'formik';
import Panel from 'app/components/Layout/Panel';

const StyledButtonAssignButton = styled(Button)`
  padding-left: 0;
`;

const StyledInspectorCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  .ant-card-meta-title {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
    color: #8991a0;
  }
  .ant-card-meta-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.005em;
    text-align: left;
    color: #232b3a;
    > ul {
      padding-left: 0;
      li {
        margin-top: 4px;
        list-style: none;
      }
    }
  }
  .ant-card-grid {
    box-shadow: none;
  }
`;
const StyledFormItem = styled(Form.Item)`
  > div {
    > .ant-form-item-label {
      label {
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0.03em;
        text-align: left;
        color: rgba(35, 43, 58, 1);
      }
    }
  }
  .ant-form-item-control-input-content {
    > div:not(.ant-list) {
      width: 400px;
    }
  }
  .ant-list-empty-text {
    display: none;
  }
`;

const Item = styled(List.Item)`
  width: 100%;
  border-bottom: none !important;
  .ant-card {
    width: 100%;
    .ant-card-body {
      padding: 16px;
    }
  }
`;
const SelectInspector = (props: { inspectionId: string | number }) => {
  const { values, setFieldValue }: any = useFormikContext();
  const { inspectionRequirement, factory } = values;
  const { inspectionId } = props;
  const isDisabled =
    !inspectionRequirement.inspectionDate ||
    !inspectionRequirement.inspectionEndDate ||
    !inspectionRequirement.noOfManday;

  const [openAssignInspector, setOpenAssignInspector] = React.useState(false);

  const handleTransform = (schedules) => {
    return schedules.reduce((acc, current) => {
      const { inspectors, inspectionDate } = current;
      inspectors.forEach(({ inspector, manDay }) => {
        const assignedInspectorIdx = acc.findIndex(
          ({ userId }) => userId === inspector.id
        );
        if (assignedInspectorIdx < 0) {
          acc.push({
            ...inspector,
            inspectionDates: [
              {
                date: inspectionDate,
                manday: manDay
              }
            ],
            userId: inspector.id,
            inspector
          });
        } else {
          const assignedInspector = acc[assignedInspectorIdx];
          assignedInspector.inspectionDates = [
            ...assignedInspector.inspectionDates,
            {
              date: inspectionDate,
              manday: manDay
            }
          ];
          acc[assignedInspectorIdx] = {
            ...assignedInspector
          };
        }
      });
      return acc;
    }, []);
  };

  return (
    <Panel title="3. Inspector Information">
      <Field name="inspectionRequirement">
        {({ field: { value: requirement } }) => {
          return (
            <React.Fragment>
              <Field name="inspectionRequirement.noOfManday">
                {({ field, meta }) => {
                  return (
                    <StyledFormItem
                      colon={false}
                      label="Mandays"
                      validateStatus={meta.error ? 'error' : ''}
                      help={meta.error}
                    >
                      <InputNumber
                        onChange={(value) => {
                          field.onChange({
                            target: {
                              name: field.name,
                              value
                            }
                          });
                        }}
                        value={field.value}
                        min={0.1}
                        step={0.1}
                      ></InputNumber>
                    </StyledFormItem>
                  );
                }}
              </Field>
              <StyledFormItem label="Inspection Period">
                <Field name="inspectionRequirement.inspectionDate">
                  {({ field, meta }) => {
                    const value = field.value
                      ? moment(field.value, 'DD/MM/YYYY')
                      : undefined;
                    return (
                      <Form.Item
                        label="Inspection Start Date"
                        validateStatus={meta.error ? 'error' : ''}
                        help={meta.error}
                      >
                        <DatePicker
                          onChange={(_, _dateString) => {
                            field.onChange({
                              target: {
                                name: field.name,
                                value: _dateString
                              }
                            });
                          }}
                          value={value}
                          format={'DD/MM/YYYY'}
                        ></DatePicker>
                      </Form.Item>
                    );
                  }}
                </Field>
                <Field name="inspectionRequirement.inspectionEndDate">
                  {({ field, meta }) => {
                    const value = field.value
                      ? moment(field.value, 'DD/MM/YYYY')
                      : undefined;
                    return (
                      <Form.Item
                        label="Inspection End Date"
                        validateStatus={meta.error ? 'error' : ''}
                        help={meta.error}
                      >
                        <DatePicker
                          onChange={(_, _dateString) => {
                            field.onChange({
                              target: {
                                name: field.name,
                                value: _dateString
                              }
                            });
                          }}
                          value={value}
                          format={'DD/MM/YYYY'}
                          disabledDate={(date) => {
                            const startDate = requirement.inspectionDate;
                            return (
                              date
                                .startOf('day')
                                .diff(
                                  (isMoment(startDate)
                                    ? startDate
                                    : moment(startDate, 'DD/MM/YYYY')
                                  ).startOf('day'),
                                  'days'
                                ) < 0
                            );
                          }}
                        ></DatePicker>
                      </Form.Item>
                    );
                  }}
                </Field>
              </StyledFormItem>
              <Field name="inspectionRequirement.assignTo">
                {({ field }) => {
                  return (
                    <>
                      <List
                        locale={{ emptyText: <></> }}
                        dataSource={field.value}
                        renderItem={({
                          inspector,
                          firstName,
                          lastName,
                          inspectionDates
                        }: any) => {
                          const total = sum(
                            (inspectionDates || []).map(
                              ({ manday }: Record<string, any>) => manday || 0
                            )
                          );
                          return (
                            <Item>
                              <Card>
                                <StyledInspectorCardContent>
                                  <Card.Grid hoverable={false}>
                                    <Card.Meta
                                      avatar={
                                        <Avatar
                                          placeholder={
                                            Avatar.PLACE_HOLDERS['USER_PROFILE']
                                          }
                                        ></Avatar>
                                      }
                                      title="Inspector Name"
                                      description={`${firstName} ${lastName}`}
                                    ></Card.Meta>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false}>
                                    <Card.Meta
                                      title={`Schedule (${total} ${
                                        total > 1 ? 'days' : 'day'
                                      })`}
                                      description={
                                        <ul>
                                          {(inspectionDates || []).map(
                                            (
                                              inspectionDate: any,
                                              index: number
                                            ) => {
                                              return (
                                                <li key={index}>
                                                  {moment(
                                                    inspectionDate.date
                                                  ).format('DD/MM/YYYY')}{' '}
                                                  ({inspectionDate.manday} day)
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      }
                                    ></Card.Meta>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false}>
                                    <Card.Meta
                                      title="Contact Number"
                                      description={
                                        inspector?.phone ||
                                        inspector?.contactNumber ||
                                        'N/A'
                                      }
                                    ></Card.Meta>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false}>
                                    <Card.Meta
                                      title="Email"
                                      description={inspector?.email || 'N/A'}
                                    ></Card.Meta>
                                  </Card.Grid>
                                </StyledInspectorCardContent>
                              </Card>
                            </Item>
                          );
                        }}
                        footer={
                          <StyledButtonAssignButton
                            disabled={isDisabled}
                            type="link"
                            onClick={() => {
                              // setModalExtraProps({
                              //   manDay: requirement.noOfManday,
                              //   inspectionStart:
                              //     requirement?.inspectionStartDate,
                              //   inspectionEnd: requirement.inspectionEndDate
                              // });
                              setOpenAssignInspector(true);
                            }}
                          >
                            Arrange inspector
                          </StyledButtonAssignButton>
                        }
                      ></List>
                      <ModalAssignInspector
                        manDay={requirement.noOfManday}
                        inspectionStart={moment(
                          requirement?.inspectionDate,
                          'DD/MM/YYYY'
                        )}
                        inspectionEnd={moment(
                          requirement?.inspectionEndDate,
                          'DD/MM/YYYY'
                        )}
                        inspectionId={inspectionId}
                        assigned={field.value?.map((assigned) => {
                          const {
                            userId,
                            inspectionDates,
                            firstName,
                            lastName
                          } = assigned;
                          return {
                            ...assigned,
                            inspectorId: userId,
                            inspector: {
                              ...assigned,
                              id: userId,
                              value: userId,
                              label: `${firstName} ${lastName}`
                            },
                            inspectionDates: inspectionDates?.map(
                              ({ date, manday }) => {
                                return {
                                  date: moment(new Date(date), 'DD/MM/YYYY'),
                                  manDay: manday
                                };
                              }
                            )
                          };
                        })}
                        onOk={(nextValues) => {
                          setOpenAssignInspector(false);
                          const transformed = handleTransform(
                            nextValues.assignTo
                          );
                          field.onChange({
                            target: field.name,
                            value: transformed
                          });
                          setFieldValue(field.name, transformed);
                          // form.setFieldValue('assignTo', transformed);
                        }}
                        factory={factory}
                        onCancel={() => {
                          setOpenAssignInspector(false);
                        }}
                        open={openAssignInspector}
                      ></ModalAssignInspector>
                    </>
                  );
                }}
              </Field>
            </React.Fragment>
          );
        }}
      </Field>
    </Panel>
  );
};

export default SelectInspector;
